import axios from 'axios';
import { logger, stats } from '@fiverr-private/obs';
import { get } from 'lodash';
import { BUSINESS_POTENTIAL } from '../../constants/acquisition';
import { serialize } from '../../utils/common';
import { BusinessPotentialModel } from '../../models/acquisition';

/** @type {import('types/services/acquisition').getBusinessPotential} */
const getBusinessPotential = async (params) => {
    try {
        const { data, status } = await axios.get(BUSINESS_POTENTIAL, {
            params: serialize(params),
        });

        stats.count('business_potential_client_fetch', status.toString());

        return new BusinessPotentialModel(data);
    } catch (error) {
        logger.warn(error);
        const status = get(error, 'response.status', 'compute_error');
        stats.count('business_potential_client_fetch', status.toString());
        throw error;
    }
};

export default getBusinessPotential;
